// extracted by mini-css-extract-plugin
export default {"loading":"SP7VhhqVL1UDvdi0m2pW"};